/**
 * Type guard for a non-empty array value.
 * @param value - Value to test.
 * @returns Whether `value` is an array with at least one element.
 * @example
 * isNonEmptyArray(['a']); // true
 * isNonEmptyArray([]); // false
 * isNonEmptyArray(null); // false
 */
export function isNonEmptyArray<T>(value: unknown): value is T[] {
	return Array.isArray(value) && value.length > 0;
}
